import React, { Component } from 'react';

import './css/GapQuestion.css';
import StringUtils from "../../utils/StringUtils";

class GapQuestion extends Component {
    componentWillMount() {
        let gapCount = 0;
        for (const subtask of this.props.subtasks) {
            gapCount += (subtask.match(/{%s}/g) || []).length;
        }
        const answers = new Array(gapCount).fill('');
        this.setState({ answers: answers });
    }

    componentDidMount() {
        this.props.saveAnswer(this.props.id, this.state.answers);
    }

    handleChange = (number, event) => {
        const answers = this.state.answers;
        answers[number] = event.target.value;
        this.setState({ answers: answers });
        this.props.saveAnswer(this.props.id, answers);
    };

    render() {
        let gapIndex = 0;
        const subtasks = this.props.subtasks.map((subtask, taskIndex) => {
            const content = subtask
                .split("{%s}")
                .map((item, index, array) => {
                    const key = "gap-" + taskIndex + "-" + index;
                    if (index < array.length - 1) {
                        const gap = gapIndex;
                        gapIndex += 1;
                        return (
                            <span key={key}>{StringUtils.parse(item)}
                            <input
                                type="text"
                                className="gap"
                                value={this.state.answers[gap]}
                                onChange={(event) => this.handleChange(gap, event)}
                                onInput={(event) => this.handleChange(gap, event)}
                            />
                            </span>)
                    }
                    return (<span key={key}>{StringUtils.parse(item)}</span>);
                });

            return (
                <div key={"subtask-" + taskIndex} className="subtask">
                    {content}
                </div>
            );
        });

        return (
            <div className="task-block gap-question">
                <div className="question-number">Pytanie {this.props.questionNumber}</div>
                <div className="question">{StringUtils.parse(this.props.question)}</div>
                <div className="subtasks">
                    {subtasks}
                </div>
            </div>
        );
    }
}

export default GapQuestion;